<template>
<div>
  <van-field required readonly right-icon="arrow" name="picker" input-align="right" :value="zhoushuValue" label="轴数" placeholder="点击选择轴数" @click="showZhoushuPickerPop" :rules="[{ validator:validator, message: '请选择轴数' }]">
    <template #label>
      <span class="input-left-label-hq">轴数</span>
    </template>
  </van-field>
  <van-popup v-model="showZhouShuPicker" position="bottom">
    <van-picker title="标题" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="onCancel" />
  </van-popup>
</div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      columns: ['一轴', '二轴', '三轴', '四轴', '五轴', '六轴'],
      showZhouShuPicker: false,
    };
  },
  props:{
    zhoushuValue: {
      type: String,
      default: ""
    },
    pickRequire:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    showZhoushuPickerPop() {
      this.showZhouShuPicker = true;
    },
    onConfirm(value) {
      this.$emit('getZhouShu', value)
      this.onCancel()
    },
    onCancel() {
      this.showZhouShuPicker = false;
    },
    validator(val) {
      if (this.pickRequire) {
        if (!val) {
          Toast.fail('请填写轴数');
          return false;
        }
        return val;
      }
    },
  },
};
</script>
